import { render, staticRenderFns } from "./sessions-list.vue?vue&type=template&id=158477b2&"
import script from "./sessions-list.vue?vue&type=script&lang=js&"
export * from "./sessions-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('158477b2')) {
      api.createRecord('158477b2', component.options)
    } else {
      api.reload('158477b2', component.options)
    }
    module.hot.accept("./sessions-list.vue?vue&type=template&id=158477b2&", function () {
      api.rerender('158477b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/sessions/sessions-list.vue"
export default component.exports